<mat-form-field *ngIf="showMunicipality.length != 0" class="w-full fuse-mat-bold fuse-mat-dense">
    <mat-label>{{ label | transloco }}</mat-label>
    <mat-select id="zones-select" [formControl]="zonesControl" multiple [compareWith]="compareZones"
                (openedChange)="openedChange($event)">
        <!-- Search input -->
        <mat-form-field class="sticky top-0 bg-white z-20 p-2 w-full">
            <input
                #searchTermInput
                matInput
                [formControl]="searchTermControl"
                type="text"
                placeholder="{{ 'SEARCH' | transloco }}"
                (keydown)="$event.stopPropagation()"
            />
            <button [disableRipple]="true" *ngIf="!!searchTermControl?.value" matSuffix
                    mat-icon-button aria-label="Clear" (click)="clearSearch($event)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <mat-select-trigger>
            <div class="flex flex-wrap gap-2 py-2 px-2">
                <ng-container *ngFor="let zone of zonesControl?.value">
                    <mat-chip *ngIf="!allMunicipalitiesChecked({zone: zone?.zone})" [removable]="true"
                              (removed)="remove(zone)">
                                    <span>
                                        {{ zone?.zone?.name + (!!zone?.municipality?.name ? ' > ' + zone?.municipality?.name: '') }}
                                    </span>
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </ng-container>
                <ng-container *ngFor="let zone of zones">
                    <mat-chip *ngIf="allMunicipalitiesChecked({zone: zone})" [removable]="true"
                              (removed)="removeProvince(zone)">
                                    <span>
                                        {{ zone?.name }}
                                    </span>
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </ng-container>
            </div>
        </mat-select-trigger>

        <!-- No results message-->
        <div
            *ngIf="allZonesVisible()"
            class="text-black no-results-option p-4 text-center">
            {{ 'NO_RESULTS' | transloco }}
        </div>

        <!-- Provincias -->
        <ng-container *ngFor="let zone of zones; let i = index">
            <mat-optgroup [ngClass]="{'hidden': showZones[i]}">
                <div
                    class="absolute left-0 top-0 w-full flex flex-row justify-between items-center hover:cursor-pointer hover:bg-[#F5F5F5] px-4 z-10"
                    (click)="toggleMunicipalities(i)">
                    <div class="flex flex-row justify-start gap-2 items-center">
                        <mat-checkbox (change)="selectProvince($event, zone)"
                                      (click)="$event.stopPropagation()"
                                      [checked]="allMunicipalitiesChecked({zone: zone})"></mat-checkbox>
                        <span>
                            {{ zone?.name }}
                        </span>
                    </div>
                    <div class="mr-6">
                        <mat-icon>{{ allMunicipalities(i) ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                    </div>
                </div>
                <!-- Municipios -->
                <ng-container *ngFor="let municipality of zone?.municipalities; let j = index">
                    <mat-option class="pl-10" [ngClass]="{'hidden': showMunicipality[i][j] || municipality?.id === ''}"
                                [value]="{zone,municipality}">
                        {{ municipality?.name }}
                    </mat-option>
                </ng-container>
            </mat-optgroup>
        </ng-container>
    </mat-select>
    <mat-error *ngIf="zonesControl?.hasError('required')">
        {{ 'COMMON.REQUIRED_FIELD' | transloco }}
    </mat-error>
</mat-form-field>
